import UploadCaptionsModal from './UploadCaptionsModal';

export default UploadCaptionsModal;
